import React from 'react';
import Localize from 'react-intl-universal';

import { Field } from 'formik';

import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';

const CreateFieldsFromConfig = ({
  config = {},
  setFieldValue = () => {},
  optionsObj = {},
  handleFields = () => {}
}) => {
  return (
    <>
      {config.map((field) => {
        const inner = handleFields?.[field?.name] || (() => {});
        const linkLabel = field.linkLabel ? { linkLabel: `${Localize.get(field.linkLabel)}` } : {};
        const isIcon = field.isIcon ? { isIcon: field.isIcon } : {};
        return (
          <Grid item xs={field?.xs || 12} sm={field?.sm || 6} sx={{ mb: 1 }} key={field?.name}>
            <FormControl
              fullWidth
              size={field?.size || 'small'}
              margin={field?.margin || 'none'}
              sx={{ alignItems: null }}
            >
              <Field
                name={field?.name}
                required={field?.required || false}
                label={`${Localize.get(field.label)}`}
                component={field.component}
                options={optionsObj[field.options] || []}
                {...inner(setFieldValue)}
                {...linkLabel}
                {...isIcon}
              />
            </FormControl>
          </Grid>
        );
      })}
    </>
  );
};
export default CreateFieldsFromConfig;
